"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var logger_1 = require("./logger");

var errors_1 = require("./errors");
/**
 *  @ignore
 */


exports.BLOCKSTACK_HANDLER = 'blockstack';
/**
 * Time
 * @private
 * @ignore
 */

function nextYear() {
  return new Date(new Date().setFullYear(new Date().getFullYear() + 1));
}

exports.nextYear = nextYear;
/**
 * Time
 * @private
 * @ignore
 */

function nextMonth() {
  return new Date(new Date().setMonth(new Date().getMonth() + 1));
}

exports.nextMonth = nextMonth;
/**
 * Time
 * @private
 * @ignore
 */

function nextHour() {
  return new Date(new Date().setHours(new Date().getHours() + 1));
}

exports.nextHour = nextHour;
/**
 * Converts megabytes to bytes. Returns 0 if the input is not a finite number.
 * @ignore
 */

function megabytesToBytes(megabytes) {
  if (!Number.isFinite(megabytes)) {
    return 0;
  }

  return Math.floor(megabytes * 1024 * 1024);
}

exports.megabytesToBytes = megabytesToBytes;
/**
 * Calculate the AES-CBC ciphertext output byte length a given input length.
 * AES has a fixed block size of 16-bytes regardless key size.
 * @ignore
 */

function getAesCbcOutputLength(inputByteLength) {
  // AES-CBC block mode rounds up to the next block size. 
  var cipherTextLength = (Math.floor(inputByteLength / 16) + 1) * 16;
  return cipherTextLength;
}

exports.getAesCbcOutputLength = getAesCbcOutputLength;
/**
 * Calculate the base64 encoded string length for a given input length.
 * This is equivalent to the byte length when the string is ASCII or UTF8-8
 * encoded.
 * @param number
 */

function getBase64OutputLength(inputByteLength) {
  var encodedLength = Math.ceil(inputByteLength / 3) * 4;
  return encodedLength;
}

exports.getBase64OutputLength = getBase64OutputLength;
/**
 * Query Strings
 * @private
 * @ignore
 */

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])".concat(key, "=.*?(&|$)"), 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';

  if (uri.match(re)) {
    return uri.replace(re, "$1".concat(key, "=").concat(value, "$2"));
  } else {
    return "".concat(uri).concat(separator).concat(key, "=").concat(value);
  }
}

exports.updateQueryStringParameter = updateQueryStringParameter;
/**
 * Versioning
 * @param {string} v1 - the left half of the version inequality
 * @param {string} v2 - right half of the version inequality
 * @returns {bool} iff v1 >= v2
 * @private
 * @ignore
 */

function isLaterVersion(v1, v2) {
  if (v1 === undefined) {
    v1 = '0.0.0';
  }

  if (v2 === undefined) {
    v2 = '0.0.0';
  }

  var v1tuple = v1.split('.').map(function (x) {
    return parseInt(x, 10);
  });
  var v2tuple = v2.split('.').map(function (x) {
    return parseInt(x, 10);
  });

  for (var index = 0; index < v2.length; index++) {
    if (index >= v1.length) {
      v2tuple.push(0);
    }

    if (v1tuple[index] < v2tuple[index]) {
      return false;
    }
  }

  return true;
}

exports.isLaterVersion = isLaterVersion;
/**
 * UUIDs
 * @private
 * @ignore
 */

function makeUUID4() {
  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
}

exports.makeUUID4 = makeUUID4;
/**
 * Checks if both urls pass the same origin check & are absolute
 * @param  {[type]}  uri1 first uri to check
 * @param  {[type]}  uri2 second uri to check
 * @return {Boolean} true if they pass the same origin check
 * @private
 * @ignore
 */

function isSameOriginAbsoluteUrl(uri1, uri2) {
  try {
    // The globally scoped WHATWG `URL` class is available in modern browsers and
    // NodeJS v10 or higher. In older NodeJS versions it must be required from the
    // `url` module.
    var parseUrl;

    if (typeof URL !== 'undefined') {
      parseUrl = function parseUrl(url) {
        return new URL(url);
      };
    } else {
      try {
        // eslint-disable-next-line import/no-nodejs-modules, global-require
        var nodeUrl = require('url').URL;

        parseUrl = function parseUrl(url) {
          return new nodeUrl(url);
        };
      } catch (error) {
        console.log(error);
        console.error('Global URL class is not available');
      }
    }

    var parsedUri1 = parseUrl(uri1);
    var parsedUri2 = parseUrl(uri2);
    var port1 = parseInt(parsedUri1.port || '0', 10) | 0 || (parsedUri1.protocol === 'https:' ? 443 : 80);
    var port2 = parseInt(parsedUri2.port || '0', 10) | 0 || (parsedUri2.protocol === 'https:' ? 443 : 80);
    var match = {
      scheme: parsedUri1.protocol === parsedUri2.protocol,
      hostname: parsedUri1.hostname === parsedUri2.hostname,
      port: port1 === port2,
      absolute: (uri1.includes('http://') || uri1.includes('https://')) && (uri2.includes('http://') || uri2.includes('https://'))
    };
    return match.scheme && match.hostname && match.port && match.absolute;
  } catch (error) {
    console.log(error);
    console.log('Parsing error in same URL origin check'); // Parse error

    return false;
  }
}

exports.isSameOriginAbsoluteUrl = isSameOriginAbsoluteUrl;
/**
 * Returns the global scope `Window`, `WorkerGlobalScope`, or `NodeJS.Global` if available in the
 * currently executing environment.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/self
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WorkerGlobalScope/self
 * @see https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope
 *
 * This could be switched to `globalThis` once it is standardized and widely available.
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
 * @ignore
 */

function getGlobalScope() {
  if (typeof self !== 'undefined') {
    return self;
  }

  if (typeof window !== 'undefined') {
    return window;
  } // This function is meant to be called when accessing APIs that are typically only available in
  // web-browser/DOM environments, but we also want to support situations where running in Node.js 
  // environment, and a polyfill was added to the Node.js `global` object scope without adding the 
  // `window` global object as well. 


  if (typeof global !== 'undefined') {
    return global;
  }

  throw new Error('Unexpected runtime environment - no supported global scope (`window`, `self`, `global`) available');
}

exports.getGlobalScope = getGlobalScope;

function getAPIUsageErrorMessage(scopeObject, apiName, usageDesc) {
  if (usageDesc) {
    return "Use of '".concat(usageDesc, "' requires `").concat(apiName, "` which is unavailable on the '").concat(scopeObject, "' object within the currently executing environment.");
  } else {
    return "`".concat(apiName, "` is unavailable on the '").concat(scopeObject, "' object within the currently executing environment.");
  }
}
/**
 * Returns an object from the global scope (`Window` or `WorkerGlobalScope`) if it
 * is available within the currently executing environment.
 * When executing within the Node.js runtime these APIs are unavailable and will be
 * `undefined` unless the API is provided via polyfill.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/self
 * @ignore
 */


function getGlobalObject(name) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      throwIfUnavailable = _ref.throwIfUnavailable,
      usageDesc = _ref.usageDesc,
      returnEmptyObject = _ref.returnEmptyObject;

  var globalScope;

  try {
    globalScope = getGlobalScope();

    if (globalScope) {
      var obj = globalScope[name];

      if (obj) {
        return obj;
      }
    }
  } catch (error) {
    logger_1.Logger.error("Error getting object '".concat(name, "' from global scope '").concat(globalScope, "': ").concat(error));
  }

  if (throwIfUnavailable) {
    var errMsg = getAPIUsageErrorMessage(globalScope, name.toString(), usageDesc);
    logger_1.Logger.error(errMsg);
    throw new Error(errMsg);
  }

  if (returnEmptyObject) {
    return {};
  }

  return undefined;
}

exports.getGlobalObject = getGlobalObject;
/**
 * Returns a specified subset of objects from the global scope (`Window` or `WorkerGlobalScope`)
 * if they are available within the currently executing environment.
 * When executing within the Node.js runtime these APIs are unavailable will be `undefined`
 * unless the API is provided via polyfill.
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/self
 * @ignore
 */

function getGlobalObjects(names) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      throwIfUnavailable = _ref2.throwIfUnavailable,
      usageDesc = _ref2.usageDesc,
      returnEmptyObject = _ref2.returnEmptyObject;

  var globalScope;

  try {
    globalScope = getGlobalScope();
  } catch (error) {
    logger_1.Logger.error("Error getting global scope: ".concat(error));

    if (throwIfUnavailable) {
      var errMsg = getAPIUsageErrorMessage(globalScope, names[0].toString(), usageDesc);
      logger_1.Logger.error(errMsg);
      throw errMsg;
    } else if (returnEmptyObject) {
      globalScope = {};
    }
  }

  var result = {};

  for (var i = 0; i < names.length; i++) {
    var name = names[i];

    try {
      if (globalScope) {
        var obj = globalScope[name];

        if (obj) {
          result[name] = obj;
        } else if (throwIfUnavailable) {
          var _errMsg = getAPIUsageErrorMessage(globalScope, name.toString(), usageDesc);

          logger_1.Logger.error(_errMsg);
          throw new Error(_errMsg);
        } else if (returnEmptyObject) {
          result[name] = {};
        }
      }
    } catch (error) {
      if (throwIfUnavailable) {
        var _errMsg2 = getAPIUsageErrorMessage(globalScope, name.toString(), usageDesc);

        logger_1.Logger.error(_errMsg2);
        throw new Error(_errMsg2);
      }
    }
  }

  return result;
}

exports.getGlobalObjects = getGlobalObjects;

function getGaiaErrorResponse(response) {
  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var responseMsg, responseJson, status, statusText, body;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            responseMsg = '';
            _context.prev = 1;
            _context.next = 4;
            return response.text();

          case 4:
            responseMsg = _context.sent;

            try {
              responseJson = JSON.parse(responseMsg);
            } catch (error) {// Use text instead
            }

            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            logger_1.Logger.debug("Error getting bad http response text: ".concat(_context.t0));

          case 11:
            status = response.status;
            statusText = response.statusText;
            body = responseJson || responseMsg;
            return _context.abrupt("return", {
              status: status,
              statusText: statusText,
              body: body
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));
}
/**
 * Returns a BlockstackError correlating to the given HTTP response,
 * with the provided errorMsg. Throws if the HTTP response is 'ok'.
 */


function getBlockstackErrorFromResponse(response, errorMsg, hubConfig) {
  var _a;

  return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var gaiaResponse, maxBytes;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!response.ok) {
              _context2.next = 2;
              break;
            }

            throw new Error('Cannot get a BlockstackError from a valid response.');

          case 2:
            _context2.next = 4;
            return getGaiaErrorResponse(response);

          case 4:
            gaiaResponse = _context2.sent;

            if (!(gaiaResponse.status === 401)) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", new errors_1.ValidationError(errorMsg, gaiaResponse));

          case 9:
            if (!(gaiaResponse.status === 402)) {
              _context2.next = 13;
              break;
            }

            return _context2.abrupt("return", new errors_1.NotEnoughProofError(errorMsg, gaiaResponse));

          case 13:
            if (!(gaiaResponse.status === 403)) {
              _context2.next = 17;
              break;
            }

            return _context2.abrupt("return", new errors_1.BadPathError(errorMsg, gaiaResponse));

          case 17:
            if (!(gaiaResponse.status === 404)) {
              _context2.next = 21;
              break;
            }

            throw new errors_1.DoesNotExist(errorMsg, gaiaResponse);

          case 21:
            if (!(gaiaResponse.status === 409)) {
              _context2.next = 25;
              break;
            }

            return _context2.abrupt("return", new errors_1.ConflictError(errorMsg, gaiaResponse));

          case 25:
            if (!(gaiaResponse.status === 412)) {
              _context2.next = 29;
              break;
            }

            return _context2.abrupt("return", new errors_1.PreconditionFailedError(errorMsg, gaiaResponse));

          case 29:
            if (!(gaiaResponse.status === 413)) {
              _context2.next = 34;
              break;
            }

            maxBytes = megabytesToBytes((_a = hubConfig) === null || _a === void 0 ? void 0 : _a.max_file_upload_size_megabytes);
            return _context2.abrupt("return", new errors_1.PayloadTooLargeError(errorMsg, gaiaResponse, maxBytes));

          case 34:
            return _context2.abrupt("return", new Error(errorMsg));

          case 35:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

exports.getBlockstackErrorFromResponse = getBlockstackErrorFromResponse;